import axios, { AxiosPromise } from 'axios'
import { ITemedRequest, ITemedResponse, ISmartResult, IInsurance, ICity, IProvider, IDoctor } from '../models';

const API_HOST = process.env.CONSULT_HOST;

export const DEFAULT_STATE = "NY";

export const STATES = {
  AK: "Alaska",
  AL: "Alabama",
  AR: "Arkansas",
  AS: "American Samoa",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  MD: "Maryland",
  ME: "Maine",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VI: "Virgin Islands",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming"
};

export function searchSmart(term: string): AxiosPromise<ISmartResult>{
  return axios.get<ISmartResult>(`${API_HOST}/api/v3/search/smart?term=${encodeURIComponent(term)}`);
}

export function getInsurances(): AxiosPromise<IInsurance[]>{
  return axios.get<IInsurance[]>(`${API_HOST}/api/v1/dictionaries/insurances.json`);
}

export function searchCity(search: string, page: number = 1, perPage: number = 5): AxiosPromise<ITemedResponse<ICity>>{
  let url = `${API_HOST}/api/v3/dictionaries/cities?page=${page}&per_page=${perPage}`;
  if(!isNaN(parseInt(search))){
    url += '&zip=' + search;
  }else{
    url += '&name=' + encodeURIComponent(search);
  }
  return axios.get<ITemedResponse<ICity>>(url);
}

export function searchProviders(request: ITemedRequest): AxiosPromise<ITemedResponse<IProvider>> {
  const queryString = requestToQuery(request);
  return axios.get<ITemedResponse<IProvider>>(`${API_HOST}/api/v3/search/providers?${queryString}`);
}

export function getDoctorInfo(slug: string): AxiosPromise<IDoctor>{
  return axios.get<IDoctor>(`${API_HOST}/api/v1/providers/by_slug/${slug}.json`);
}


export function requestToQuery (request: ITemedRequest): string{
  let query = '';
  const queryParts =[];
  for(const key in request){
    if(request[key]){
      queryParts.push('search['+key+']='+ request[key]);
    }
  }
  query = queryParts.join('&');
  return query;
}
